import type { ResidentStatus } from '@/shared/firebase/types';

const MAP: Record<ResidentStatus, { label: string; cls: string; dot: string }> = {
  inside:  { label: 'En zona',     cls: 'bg-success-50 text-success',  dot: 'bg-success' },
  outside: { label: 'Fuera',       cls: 'bg-warning-50 text-warning',  dot: 'bg-warning' },
  sos:     { label: 'SOS',         cls: 'bg-danger-50  text-danger',   dot: 'bg-danger animate-pulse' },
  offline: { label: 'Sin señal',   cls: 'bg-slate-100  text-slate-500',dot: 'bg-slate-400' },
};

export function StatusBadge({ status }: { status: ResidentStatus }) {
  const m = MAP[status];
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${m.cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />
      {m.label}
    </span>
  );
}
